import { Component, signal } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { HasRoleDirective } from "@shared/directives/has-role.directive";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { ExportTypeEnum } from "@models/common/export-type.enum";
import { Relationship } from "@models/relationships/relationship";
import { ButtonComponent } from "@shared/controls/button/button.component";
import { DividerComponent } from "@shared/components/commons/divider/divider.component";

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<Relationship> & {
  exportShares: ActionEvent;
  resolveIssue: ActionEvent;
  issueTransaction: ActionEvent;
  transferTransaction: ActionEvent;
  cancelTransaction: ActionEvent;
  subdivisionOrConsolidationTransaction: ActionEvent;
  conversionTransaction: ActionEvent;
  changeAmountPaidTransaction: ActionEvent;
  addHistoryTransaction: ActionEvent;
  hasIssue: boolean;
  isCompanyLoading: boolean;
};

@Component({
  selector: 'app-ag-share-group-buttons',
  standalone: true,
  imports: [
    ButtonComponent,
    DividerComponent,
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownToggle,
    HasRoleDirective,
    NgbDropdownItem
  ],
  templateUrl: './ag-share-group-buttons.component.html',
  styleUrl: './ag-share-group-buttons.component.scss'
})
export class AgShareGroupButtonsComponent implements ICellRendererAngularComp {
  public addTransactionMenu: { name: string; action: () => void }[] = [
    { name: 'Issue', action: () => this.issueTransaction() },
    { name: 'Transfer', action: () => this.transferTransaction() },
    { name: 'Cancellation', action: () => this.cancelTransaction() },
    // { name: 'Subdivision or Consolidation', action: () => this.subdivisionOrConsolidationTransaction() },
    // { name: 'Conversion', action: () => this.conversionTransaction() },
    // { name: 'Change Amount Paid', action: () => this.changeAmountPaidTransaction() },
    { name: 'Add Historical Transaction', action: () => this.addHistoryTransaction() },
  ];

  params!: CellRendererParams;
  hasIssue = false;
  isCompanyLoading = signal(false);
  checkedShares = [];

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.hasIssue = params.hasIssue;
    this.isCompanyLoading.set(params.isCompanyLoading ?? false);
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    this.isCompanyLoading.set(params.isCompanyLoading ?? false);
    return false;
  }

  exportSharesList(status: boolean, exportType: ExportTypeEnum): void {
    this.params.exportShares(exportType);
  }

  resolveIssue(): void {
    this.params.resolveIssue(true);
  }

  issueTransaction(): void {
    this.params.issueTransaction(true);
  }

  transferTransaction(): void {
    this.params.transferTransaction(true);
  }

  cancelTransaction(): void {
    this.params.cancelTransaction(true);
  }

  subdivisionOrConsolidationTransaction(): void {
    this.params.subdivisionOrConsolidationTransaction(true);
  }

  conversionTransaction(): void {
    this.params.conversionTransaction(true);
  }

  changeAmountPaidTransaction(): void {
    this.params.changeAmountPaidTransaction(true);
  }

  addHistoryTransaction(): void {
    this.params.addHistoryTransaction(true);
  }

  protected readonly ExportTypeEnum = ExportTypeEnum;
}
